import { pickId, pickOne, searchOf } from '../../lib/searchFilter'
import { ALERT_PAPERS, ALERT_SITUATIONS, OWNER_TYPES, type AlertFilter } from './api'

/** The alert list's filters as its address spells them: `?kind=Driver&paper=Cdl&situation=Expired&carrier=…`. */
export function alertFilterFrom(search: URLSearchParams): AlertFilter {
  return {
    ownerType: pickOne(search.get('kind'), OWNER_TYPES),
    documentType: pickOne(search.get('paper'), ALERT_PAPERS),
    situation: pickOne(search.get('situation'), ALERT_SITUATIONS),
    carrierId: pickId(search.get('carrier')),
  }
}

/** The address a filter is written to. */
export function alertSearchFrom(filter: AlertFilter): URLSearchParams {
  return searchOf([
    ['kind', filter.ownerType],
    ['paper', filter.documentType],
    ['situation', filter.situation],
    ['carrier', filter.carrierId],
  ])
}

/** Whether the list shows less than everything that needs attention. */
export function isAlertListNarrowed(filter: AlertFilter): boolean {
  return Object.values(filter).some((value) => value !== undefined)
}
